// extracted by mini-css-extract-plugin
export default {"carouselVisibleVideo":"LegacyTheme_carouselVisibleVideo__IpXib","carouselHiddenVideo":"LegacyTheme_carouselHiddenVideo__thR08"};